import React from 'react';
import { get as _get } from 'lodash';
import { Task, TaskTypeId } from '@bringg/types';
import Label from '../label/label';
export interface Translations {
	collectText: string;
	deliverText: string;
}

interface LinkedTasksProps {
	tasks: Task[];
	translations: Translations;
	navigateToTask: (taskId: number) => void;
}

const getLabel = (task: Task, translations: Translations) => {
	const taskTypeId: TaskTypeId = _get(task, 'task_type_id');
	switch (taskTypeId) {
		case TaskTypeId.PICKUP:
			return <Label text={translations.collectText} size="small" className="pickup" />;

		case TaskTypeId.DELIVERY:
			return <Label text={translations.deliverText} size="small" className="delivery" />;

		case TaskTypeId.PICKUP_AND_DELIVERY:
			return (
				<>
					<Label text={translations.collectText} size="small" className="pickup" />
					<Label text={translations.deliverText} size="small" className="delivery" />
				</>
			);

		default:
			return <></>;
	}
};

const LinkedTasks: React.FC<LinkedTasksProps> = ({ translations, tasks, navigateToTask }) => {
	return (
		<div className="tasks-container">
			{tasks.map(task => (
				<div className="linked-tasks-container" key={task.id.toString()}>
					<div className="linked-task">
						<div onClick={() => navigateToTask(task.id)} className="linked-task-link">
							#{task.id}
						</div>
						<div className="linked-label">{getLabel(task, translations)}</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default LinkedTasks;
